// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/plugins.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import { file_google_api_annotations } from "../../../../google/api/annotations_pb";
import { file_google_api_client } from "../../../../google/api/client_pb";
import type { File, FileJson } from "./file_pb";
import { file_mochabugapis_adapt_plugins_v1_file } from "./file_pb";
import type { Manifest, ManifestJson } from "./manifest_pb";
import { file_mochabugapis_adapt_plugins_v1_manifest } from "./manifest_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/plugins.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_plugins: GenFile = /*@__PURE__*/
  fileDesc("Cittb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9wbHVnaW5zLnByb3RvEh1tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MSKWAQoTVXBsb2FkUGx1Z2luUmVxdWVzdBI7CgVzdGFydBgBIAEoCzIqLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLlN0YXJ0VXBsb2FkSAASMwoEZmlsZRgCIAEoCzIjLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLkZpbGVIAEINCgRkYXRhEgW6SAIIASLTBQoLU3RhcnRVcGxvYWQSOQoIbWFuaWZlc3QYASABKAsyJy5tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MS5NYW5pZmVzdBI2CgpjZG5fcHJlZml4GAIgASgJQh26SBpyGBACGIAgMhFeW14vXSsoXC9bXi9dKykqJEgAiAEBEjkKDWFzc2V0c19wcmVmaXgYAyABKAlCHbpIGnIYEAIYgCAyEV5bXi9dKyhcL1teL10rKSokSAGIAQESPwoNZXhlY3V0b3JfcGF0aBgEIAEoCUIoukglciMQAhiAIDIcXihbXi9dKygvW14vXSspKilcLihjanN8anMpJBJCCg1leGVjdXRvcl93YXNtGAUgAygJQiu6SCiSASUYASIhch8QAhiAIDIYXihbXi9dKygvW14vXSspKilcLndhc20kEkgKEWNvbmZpZ3VyYXRvcl9wYXRoGAYgASgJQii6SCVyIxACGIAgMhxeKFteL10rKC9bXi9dKykqKVwuKGNqc3xqcykkSAKIAQESRgoRY29uZmlndXJhdG9yX3dhc20YByADKAlCK7pIKJIBJRgBIiFyHxACGIAgMhheKFteL10rKC9bXi9dKykqKVwud2FzbSQSIQoUY29weV9zeXN0ZW1fc2V0dGluZ3MYCCABKAhIA4gBATqLAbpIhwEahAEKEWNvbmZpZ3VyYXRvci53YXNtEix3YXNtIGNhbm5vdCBleGlzdHMgaWYgbm8gY29uZmlndXJhdG9yIGlzIHNldBpBaGFzKHRoaXMuY29uZmlndXJhdG9yX3BhdGgpIHx8IHRoaXMuY29uZmlndXJhdG9yX3dhc20uc2l6ZSgpID09IDBCDQoLX2Nkbl9wcmVmaXhCEAoOX2Fzc2V0c19wcmVmaXhCFAoSX2NvbmZpZ3VyYXRvcl9wYXRoQhcKFV9jb3B5X3N5c3RlbV9zZXR0aW5ncyIWChRVcGxvYWRQbHVnaW5SZXNwb25zZTKvAgoNUGx1Z2luU2VydmljZRKYAQoMVXBsb2FkUGx1Z2luEjIubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuVXBsb2FkUGx1Z2luUmVxdWVzdBozLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLlVwbG9hZFBsdWdpblJlc3BvbnNlIh2C0+STAhc6ASoiEi92MS9wbHVnaW5zL3VwbG9hZCgBGoIBykEWYWRhcHQubW9jaGFidWdhcGlzLmNvbdJBZmh0dHBzOi8vd3d3Lm1vY2hhYnVnYXBpcy5jb20vYXV0aC9hZGFwdC9wbHVnaW5zLGh0dHBzOi8vd3d3Lm1vY2hhYnVnYXBpcy5jb20vYXV0aC9hZGFwdC9wbHVnaW5zLnVwbG9hZGIGcHJvdG8z", [file_buf_validate_validate, file_google_api_annotations, file_google_api_client, file_mochabugapis_adapt_plugins_v1_file, file_mochabugapis_adapt_plugins_v1_manifest]);

/**
 * UploadPluginRequest represents a single request in the CreatePlugin streaming
 * RPC. The client sends a series of UploadPluginRequest messages containing
 * plugin data, starting with a manifest and followed by one or more files.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.UploadPluginRequest
 */
export type UploadPluginRequest = Message<"mochabugapis.adapt.plugins.v1.UploadPluginRequest"> & {
  /**
   * 'data' is a oneof field that holds either a manifest or a file for the
   * plugin.
   *
   * @generated from oneof mochabugapis.adapt.plugins.v1.UploadPluginRequest.data
   */
  data: {
    /**
     * 'start' must be the first message of the stream
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.StartUpload start = 1;
     */
    value: StartUpload;
    case: "start";
  } | {
    /**
     * 'file' is a File contained within the plugin.
     * It follows the manifest in the stream.
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.File file = 2;
     */
    value: File;
    case: "file";
  } | { case: undefined; value?: undefined };
};

/**
 * UploadPluginRequest represents a single request in the CreatePlugin streaming
 * RPC. The client sends a series of UploadPluginRequest messages containing
 * plugin data, starting with a manifest and followed by one or more files.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.UploadPluginRequest
 */
export type UploadPluginRequestJson = {
  /**
   * 'start' must be the first message of the stream
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.StartUpload start = 1;
   */
  start?: StartUploadJson;

  /**
   * 'file' is a File contained within the plugin.
   * It follows the manifest in the stream.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.File file = 2;
   */
  file?: FileJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.UploadPluginRequest.
 * Use `create(UploadPluginRequestSchema)` to create a new message.
 */
export const UploadPluginRequestSchema: GenMessage<UploadPluginRequest, {jsonType: UploadPluginRequestJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_plugins, 0);

/**
 * The start message containing information about the files to be uploaded.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.StartUpload
 */
export type StartUpload = Message<"mochabugapis.adapt.plugins.v1.StartUpload"> & {
  /**
   * 'manifest' is the Manifest describing the plugin.
   * It must be the first message in the stream.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.Manifest manifest = 1;
   */
  manifest?: Manifest | undefined;

  /**
   * The 'cdn_prefix' path prefix for the plugin files.
   *
   * @generated from field: optional string cdn_prefix = 2;
   */
  cdnPrefix?: string | undefined;

  /**
   * The 'assets_prefix' path prefix for the plugin files.
   *
   * @generated from field: optional string assets_prefix = 3;
   */
  assetsPrefix?: string | undefined;

  /**
   * The executor file path
   *
   * @generated from field: string executor_path = 4;
   */
  executorPath: string;

  /**
   * Any additional wasm modules needed for the executor
   *
   * @generated from field: repeated string executor_wasm = 5;
   */
  executorWasm: string[];

  /**
   * The configurator file path
   *
   * @generated from field: optional string configurator_path = 6;
   */
  configuratorPath?: string | undefined;

  /**
   * Any additional wasm modules needed for the executor
   *
   * @generated from field: repeated string configurator_wasm = 7;
   */
  configuratorWasm: string[];

  /**
   * Whether we should copy-over previous system settings (if any) to the new
   * plugin.
   *
   * @generated from field: optional bool copy_system_settings = 8;
   */
  copySystemSettings?: boolean | undefined;
};

/**
 * The start message containing information about the files to be uploaded.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.StartUpload
 */
export type StartUploadJson = {
  /**
   * 'manifest' is the Manifest describing the plugin.
   * It must be the first message in the stream.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.Manifest manifest = 1;
   */
  manifest?: ManifestJson;

  /**
   * The 'cdn_prefix' path prefix for the plugin files.
   *
   * @generated from field: optional string cdn_prefix = 2;
   */
  cdnPrefix?: string;

  /**
   * The 'assets_prefix' path prefix for the plugin files.
   *
   * @generated from field: optional string assets_prefix = 3;
   */
  assetsPrefix?: string;

  /**
   * The executor file path
   *
   * @generated from field: string executor_path = 4;
   */
  executorPath?: string;

  /**
   * Any additional wasm modules needed for the executor
   *
   * @generated from field: repeated string executor_wasm = 5;
   */
  executorWasm?: string[];

  /**
   * The configurator file path
   *
   * @generated from field: optional string configurator_path = 6;
   */
  configuratorPath?: string;

  /**
   * Any additional wasm modules needed for the executor
   *
   * @generated from field: repeated string configurator_wasm = 7;
   */
  configuratorWasm?: string[];

  /**
   * Whether we should copy-over previous system settings (if any) to the new
   * plugin.
   *
   * @generated from field: optional bool copy_system_settings = 8;
   */
  copySystemSettings?: boolean;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.StartUpload.
 * Use `create(StartUploadSchema)` to create a new message.
 */
export const StartUploadSchema: GenMessage<StartUpload, {jsonType: StartUploadJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_plugins, 1);

/**
 * UploadPluginResponse represents the response from the CreatePlugin streaming
 * RPC. The server sends a single CreatePluginResponse after successfully
 * processing all UploadPluginResponse messages from the client.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.UploadPluginResponse
 */
export type UploadPluginResponse = Message<"mochabugapis.adapt.plugins.v1.UploadPluginResponse"> & {
};

/**
 * UploadPluginResponse represents the response from the CreatePlugin streaming
 * RPC. The server sends a single CreatePluginResponse after successfully
 * processing all UploadPluginResponse messages from the client.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.UploadPluginResponse
 */
export type UploadPluginResponseJson = {
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.UploadPluginResponse.
 * Use `create(UploadPluginResponseSchema)` to create a new message.
 */
export const UploadPluginResponseSchema: GenMessage<UploadPluginResponse, {jsonType: UploadPluginResponseJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_plugins, 2);

/**
 * PluginService provides a service for uploading a plugin.
 *
 * @generated from service mochabugapis.adapt.plugins.v1.PluginService
 */
export const PluginService: GenService<{
  /**
   * UploadPlugin is a streaming RPC method that allows uploading a plugin in
   * chunks. The client can send multiple UploadPluginRequest messages, and the
   * server will respond with a single UploadPluginResponse after processing all
   * requests.
   *
   * @generated from rpc mochabugapis.adapt.plugins.v1.PluginService.UploadPlugin
   */
  uploadPlugin: {
    methodKind: "client_streaming";
    input: typeof UploadPluginRequestSchema;
    output: typeof UploadPluginResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_mochabugapis_adapt_plugins_v1_plugins, 0);

